import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import RefferalStat from "./RefferalStat";
import ReferralListings from "./ReferralListings";
import CmnFilters from "../lead-management/common/CmnFilters";
import CommonStructured from "../common-components/CommonStructured";
import {
  fetchReferralsData,
  fetchReferralStatData,
} from "../../redux/prospect-reducers/prospectSlice";
import "../../styles/referrals/referrals.css";

const ReferralStructure = ({ userInfoData, isODM }) => {
  const dispatch = useDispatch();
  const { referralsLoading } = useSelector((state) => state.prospects);

  const isAdmin = userInfoData?.account_type === "admin";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: "",
    selAddedby: !isAdmin && !isClusterManager
      ? {
          label: userInfoData?.name || "",
          value: userInfoData?.uid || userInfoData?.user_id || "",
        }
      : "",
    isActive: "",
    accountType: "",
    selAddNotAddToLead: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    leadConvertedDateFrom: "",
    leadConvertedDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
    converted_date_from: allFilters.leadConvertedDateFrom || "",
    converted_date_to: allFilters.leadConvertedDateTo || "",
    added_by: allFilters.selAddedby?.value || "",
    conversion_status: allFilters.isActive?.value || "",
    account_type: allFilters.accountType?.value || "",
    added_to_lead: allFilters.selAddNotAddToLead?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getRefferalStatData(filters) {
    const { page, limit, ...rest } = filters;

    dispatch(
      fetchReferralStatData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getFDPaymentsAccessData(filters) {
    dispatch(
      fetchReferralsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getRefferalStatData(filters);
  }, [
    filters.gym_id,
    filters.date_from,
    filters.date_to,
    filters.converted_date_from,
    filters.converted_date_to,
    filters.added_by,
    filters.conversion_status,
    filters.account_type,
    filters.added_to_lead,
  ]);

  useEffect(() => {
    getFDPaymentsAccessData(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
      converted_date_from: allFilters.leadConvertedDateFrom || "",
      converted_date_to: allFilters.leadConvertedDateTo || "",
      added_by: allFilters.selAddedby?.value || "",
      conversion_status: allFilters.isActive?.value || "",
      account_type: allFilters.accountType?.value || "",
      added_to_lead: allFilters.selAddNotAddToLead?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.leadConvertedDateFrom,
    allFilters.leadConvertedDateTo,
    allFilters.selAddedby,
    allFilters.isActive,
    allFilters.accountType,
    allFilters.selAddNotAddToLead,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <>
      <Row>
        <Col>
          <CommonStructured
            pageHeading={"All Referrals"}
            isReload={() => {
              getFDPaymentsAccessData(filters);
              getRefferalStatData(filters);
            }}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CmnFilters
            from={"referrals"}
            userInfoData={userInfoData}
            onClickReset={onResetFilters}
            filters={allFilters}
            setFilters={setAllFilters}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
            isLoading={referralsLoading}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <RefferalStat />
        </Col>
      </Row>

      <Row>
        <Col>
          <ReferralListings
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            userInfoData={userInfoData}
            callFunction={() => {
              getFDPaymentsAccessData(filters);
              getRefferalStatData(filters);
            }}
            prevFilters={(({ limit, page, added_to_lead, ...rest }) => rest)(
              filters
            )}
          />
        </Col>
      </Row>
    </>
  );
};

export default ReferralStructure;
